import { CallEventTypes } from '@gem/call/constants';

import Entities from 'STORE';

function handleBackgroundCall(call) {
  if (call.status === CallEventTypes.Started) {
    Entities.BackgroundCalls.add(call);
  } else if (call.status === CallEventTypes.Finished) {
    Entities.BackgroundCalls.delete(call.channelId, call.groupId);
  }
}

function handleIncomingCall(call) {
  if (call.status !== CallEventTypes.Finished) {
    return;
  }

  Entities.IncomingCalls.delete(call.channelId, call.groupId);
}

function handleConfirmAwaitCall(call) {
  const group = Entities.GroupsStore.getGroupById(call.groupId);

  if (group?.isAwaitCall && Entities.App.confirm && call.status === CallEventTypes.Finished) {
    Entities.App.confirm.onClose();
  }
}

export function updateActiveCall(call) {
  handleBackgroundCall(call);
  handleIncomingCall(call);
  handleConfirmAwaitCall(call);
}
